export function isWhiteLabelProject() {
	const names = process.env.REACT_APP_PROJECT_NAME;

	const project = {
		keepa: false,
		entekhab: true,
		hamtaland: true,
		rayansaipa: true,
		demo: true,
		tisa: true,
		saana: true,
		arbaeen: true,
	};

	return project[names] || false;
}
